/**
 * ContentTooltip portal z-index SoT (Prefer-over).
 * Keep in sync with `Z_INDEX.saasContentTooltip` in apps/web shared z-index registry.
 * Above quiz VFX (300) / SaaS overlay max (260); below consent (400).
 */
export const CONTENT_TOOLTIP_Z_INDEX = 320;
